import React from "react";
import { CheckCircle2, CircleAlert, X } from "lucide-react";
import { useToast } from "../contexts/ToastContext";

export default function Toast() {
  const { toast, dismissToast } = useToast();
  if (!toast) return null;
  const Icon = toast.kind === "error" ? CircleAlert : CheckCircle2;
  return (
    <div className={`toast toast--${toast.kind}`} role="status" key={toast.id}>
      <Icon size={19} />
      <span>{toast.message}</span>
      <button className="toast_btn" aria-label="Dismiss notification" onClick={dismissToast}>
        <X size={16} />
      </button>
    </div>
  );
}
